export default {
  AVAILABLE_LIQUIDITY_BUFFER: "0x910CA844Fb578f670Ca5190c1cF4ab851155Bf99",
  ACREBTC_TOKEN: "0x19531C886339dd28b9923d903F6B235C45396ded",
  WITHDRAWAL_QUEUE: "0xe7b8c14cA8Fb4f226C0A3e45e636b84809BB5D06",
}
